export function loadDemoFoodEntries() {
  return [
    {
      id: '1',
      user_id: 'demo-user-id',
      meal_type: 'breakfast',
      food_name: 'Oatmeal with berries',
      brand: null,
      serving_size: 1,
      serving_unit: 'bowl',
      macros: {
        calories: 280,
        carbs: 45,
        protein: 8,
        fat: 6,
        fiber: 7
      },
      logged_at: new Date().toISOString(),
      created_at: new Date().toISOString()
    }
  ];
}
